import { UseMutateFunction } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { checkPresetForUpdate, checkPresetForUpdateOran } from '@api/kpi';

import { IEditPresetNameFncDTO } from '@interfaces/kpi/dto/kpiDTO';
import { IUpdatePresetNameDTO } from '@interfaces/kpi/dto/kpiPresetsDTO';

import { CHECK_UPDATE_PRESET } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

export const useMutateCheckPresetForUpdate = ({
	handleUpdatePresetName,
	isOranVendor,
}: {
	handleUpdatePresetName: UseMutateFunction<any, any, IEditPresetNameFncDTO, any>;
	isOranVendor: boolean;
}) => {
	const checkPresetForUpdateFunction = isOranVendor ? checkPresetForUpdateOran : checkPresetForUpdate;

	const {
		mutate: handleCheckUpdatePreset,
		isLoading: isLoadingCheckUpdatePreset,
	} = useMutation<IUpdatePresetNameDTO>({
		mutationKey: [CHECK_UPDATE_PRESET],
		mutationFn: async ({
			data,
			setNameError,
			closePresetForm,
			setPresetValue,
			isPresetValue,
		}: IUpdatePresetNameDTO) => {
			try {
				await checkPresetForUpdateFunction(data);
				await handleUpdatePresetName({ data, closePresetForm, setPresetValue, isPresetValue });
			} catch (err: any) {
				setNameError(err?.errors?.[0]?.message ?? responseMessages.error);
			}
		},
	});

	return {
		handleCheckUpdatePreset,
		isLoadingCheckUpdatePreset,
	};
};
